var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSubmitted = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 42.7143C17.7332 42.7143 12.7839 40.664 9.05894 36.9411C5.33398 33.2182 3.28577 28.2668 3.28577 23.0021C3.28577 17.7352 5.33605 12.7859 9.05894 9.06095C12.7818 5.33599 17.7332 3.28571 23 3.28571C28.2669 3.28571 33.2162 5.33599 36.9412 9.06095C40.6661 12.7859 42.7143 17.7352 42.7143 23.0021C42.7143 28.2689 40.664 33.2182 36.9412 36.9411C33.2183 40.664 28.2669 42.7143 23 42.7143ZM23 5.36089C13.2736 5.36089 5.36095 13.2736 5.36095 23C5.36095 32.7264 13.2736 40.6391 23 40.6391C32.7265 40.6391 40.6391 32.7264 40.6391 23C40.6391 13.2736 32.7265 5.36089 23 5.36089V5.36089Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.417 31.2143C19.1875 31.2143 18.9581 31.1237 18.7824 30.9444L13.4051 25.3993C13.0556 25.0388 13.0556 24.4529 13.4051 24.0925C13.7546 23.732 14.3228 23.732 14.6724 24.0925L19.4152 28.9833L31.3278 16.6989C31.6773 16.3385 32.2456 16.3385 32.5951 16.6989C32.9446 17.0594 32.9446 17.6453 32.5951 18.0057L20.0479 30.9444C19.8723 31.1256 19.6428 31.2143 19.4134 31.2143H19.417Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSubmitted, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/submitted.81724000.svg";
export { ForwardRef as ReactComponent };